import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMessageTemplate, deleteTemplate } from '../../../store/messagetemplate/actions';
import AddEditTemplates from './addEditTemplates';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmation'
import { messageTemplateItem } from './messageTemplateItem';

function MessageTemplate() {
    const dispatch = useDispatch();
    const { messageTemplateList } = useSelector(state => state.messagetemplatelist);
    const [showAddModal, setShowAddModal] = useState(false);
    const [templateModal, setTemplateEvent] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [messageTemplateModel, setMessageTemplateModel] = useState(messageTemplateItem);
    const currentUrl = window.location.href;
    const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
    const { isAdmin } = useSelector((state) => state.auth);

    useEffect(() => {
        const segmentToDispatch = lastSegment === "messagetemplate" ? "Custom" : lastSegment === "automatedmessagetemplate" ? "Auto" : lastSegment;
        dispatch(getMessageTemplate(segmentToDispatch));
    }, []);
   
    const handleDeleteTrigger = (id, title) => {
        setTemplateEvent({ id: id, title: title });
        setShowDeleteModal(true);
    }
    const handleDeleteEvent = (item) => {
        dispatch(deleteTemplate(item.id));
    }

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteEvent={handleDeleteEvent}
                model={templateModal}
            />

            <div className="admin-page-wrap message-templates-page">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content w-100">                      

                        
                            <div className="admin-page-title-wrap justify-content-between">
                            <h1 className="admin-page-heading">{(lastSegment == "messagetemplate") ? "Message Templates" :"Automated Message Templates"}</h1>
                            {isAdmin && (lastSegment == "messagetemplate") &&
                                <button className="admin-button create-outline-btn"
                                    onClick={() => {
                                        setShowAddModal(true);
                                        setMessageTemplateModel('');
                                    }}
                                >
                                    <span>Create Template</span>
                                    <span className="material-symbols-rounded">add</span>
                                </button>}
                                <AddEditTemplates
                                show={showAddModal}
                                lastSegment={lastSegment}
                                    onClose={() => setShowAddModal(false)}
                                    modelmessageTemplate={messageTemplateModel}
                                />
                            </div>
                        

                        <div className="pt">
                            <table className="admin-table w-100 message-table">
                                <thead>
                                    <tr>
                                        <th className="admin-table-name-cell sortable sorted-dn">Message Title</th>
                                        <th className="admin-table-name-cell ">Message Content</th>
                                        <th className="admin-table-name-cell">

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messageTemplateList && messageTemplateList.length>0 ? (
                                     messageTemplateList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="admin-table-name-cell">
                                                    <span className="bold">{item?.name}</span><br />
                                                </td>
                                                <td className="admin-table-name-cell">{item?.englishContent}</td>

                                                <td className="admin-table-name-cell">                                                   
                                                    <div className="flex-center justify-end">
                                                        <button className="admin-table-action action-icon"
                                                            onClick={() => {
                                                                setShowAddModal(true);
                                                                setMessageTemplateModel(item);
                                                            }}
                                                        >
                                                            <span className="material-symbols-outlined">
                                                                {isAdmin ? 'edit' : 'visibility'}
                                                            </span>
                                                        </button>
                                                        {isAdmin && lastSegment == "messagetemplate" &&
                                                            <button className="admin-table-action  action-icon" onClick={() => handleDeleteTrigger(item.id, item.name)}>
                                                                <span className="material-symbols-outlined">
                                                                    delete
                                                                </span>
                                                            </button>
                                                        }
                                                    </div>
                                                </td>

                                            </tr>
                                        );
                                    })
                                     
                                    ) : (
                                    <tr>
                                        <td className="admin-table-name-cell" colSpan="6">No message template found</td>
                                    </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MessageTemplate;
